import { FC, useEffect, useRef, useState } from 'react';
import { Collapse, Space, Typography } from 'antd';
import { useParams } from 'react-router';
import moment from 'moment/moment';

import { CollapseComponent, Pagination } from 'componets/ui';

import { getPrimaryMarketItemLastNews } from 'features/primaryMarket/actions';
import { language } from 'utils';
import { ProjectNews } from 'models';
import { useTranslate } from 'hooks';

import styles from './index.module.scss';

const { Panel } = Collapse;

const pageSize = 10;

type PrimaryMarketProjectNewsProps = {
	news: ProjectNews;
	setNews: (news: ProjectNews) => void;
};

export const PrimaryMarketProjectNews: FC<PrimaryMarketProjectNewsProps> = ({ news, setNews }) => {
	const { latestNewsText } = useTranslate(['latestNewsText']);
	const ref = useRef<HTMLDivElement>(null);
	const [page, setPage] = useState<number>(1);

	const { projectId } = useParams();

	useEffect(() => {
		if (projectId) {
			getPrimaryMarketItemLastNews({
				id: projectId,
				lang: language,
				params: { page, pageSize, offset: page === 1 ? 0 : +page * pageSize - pageSize },
			}).then((data) => {
				setNews(data);
			});
		}
	}, [page, projectId]);

	if (news.items?.length === 0) return null;

	return (
		<div className={styles.root} id="projectNews">
			<Typography.Title level={4} ref={ref}>
				{latestNewsText}
			</Typography.Title>

			<Space direction="vertical" size={12}>
				{news.items?.map((item) => {
					return (
						<CollapseComponent key={item.id}>
							<Panel
								key={item.id}
								header={
									<div className={styles.column}>
										<Typography.Text type="secondary">
											{moment(item.publishedAt).format('YYYY-MM-DD')}
										</Typography.Text>
										<Typography.Text>{item.title}</Typography.Text>
									</div>
								}
								className={styles.card}
							>
								<div dangerouslySetInnerHTML={{ __html: item.body }} />
							</Panel>
						</CollapseComponent>
					);
				})}
			</Space>

			{Math.ceil((news.pager?.totalCount ?? 0) / pageSize) > 1 && (
				<div className={styles.pagination}>
					<Pagination
						total={news.pager?.totalCount}
						onChange={(page: number) => {
							setPage(page);
							if (ref.current) {
								ref.current.scrollIntoView({ behavior: 'smooth' });
							}
						}}
						current={+page}
						pageSize={pageSize}
					/>
				</div>
			)}
		</div>
	);
};
